import { Phone } from '../contact/phone';

export class ProducerContactDetails {
  public phones: Phone[];
  public emails: string[];
}
